import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const ActivityTeamLayout = () => {
   const navList = useNav();
  let {activityTeamBottomNav, topActivityNav} = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={activityTeamBottomNav} topTabs={topActivityNav} />
      <Outlet />
    </div>
  )
}

export default ActivityTeamLayout;